// extracted by mini-css-extract-plugin
module.exports = {"container":"OrderPopup_container__2IFt_","selector":"OrderPopup_selector__DU9nl","actionContainer":"OrderPopup_actionContainer__1YAY7"};